import React from "react";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { LoadingSpinner } from "lib/Spinner";
import { NotAvailable } from "lib/SimpleTable";
import { useFetchDisclosures } from "../api/useFetchDisclosures";
import { InfoIconCard } from "pages/NotFound/NotFound";
import ErrorBoundary from "lib/ErrorBoundary";
import { Button } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";
import { StatementIframe } from "./StatementIframe";

export const DisclosuresStatement = () => {
  const { securityIds = "", assetClass, date } = useQueryParams();
  const securityIdsArr = securityIds.split(",");
  const [disclosures, isLoading, error] = useFetchDisclosures(date, assetClass, securityIdsArr);

  if (isLoading) return <LoadingScreen />;
  if (error) return <NotAvailable />;

  return (
    <ErrorBoundary>
      <StatementIframe disclosures={disclosures} />
      <Button variant="secondary d-block ml-auto mb-3" onClick={() => window.history.back()}>
        {_t("Back")}
      </Button>
    </ErrorBoundary>
  );
};

const LoadingScreen = () => (
  <InfoIconCard
    className="mb-5"
    title={_t("Retrieving Disclosures...")}
    body={
      <article>
        <FaIcon icon="d-block my-5 mx-auto far fa-hourglass fa-2x" />
        {_t("Please note this may take a couple of minutes.")}
        <LoadingSpinner className="mx-auto my-5" />
        {_t("Thank you for your patience.")}
      </article>
    }
  />
);
